import React from "react";
import { Col, Row } from "react-bootstrap";
import styles from "../../styles/ChatCreate.module.css";
import TopBox from "../../components/TopBox";
import { VIMEO_BASE_URL } from "../../utils/config";
import { useParams } from "react-router-dom";

export default function HowItWorks() {
  const params = useParams();

  return (
    <div>
      <div className="mx-md-5">
        <TopBox title="How it Works" />
      </div>
      <Row>
        <Col className={`${styles.Back} mt-3`} md={{ span: 8, offset: 2 }}>
          <div className={styles.TutorialLayout}>
            <div className={styles.TutorialContentColumn}>
              <h5>{params?.title}</h5>
              {/* <p>
                This is a description of the Short Call. Here you can provide
                more details about the content, its significance, or any other
                relevant information that the viewer might find useful.
              </p> */}
            </div>

            <div className={styles.TutorialVideoColumn}>
              <iframe
                className={styles.TutorialVideo}
                src={`${VIMEO_BASE_URL}${params?.video_id}`} // Replace with your dummy YouTube link
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
